import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Data Center',
    href: '#data-center'
  }, {
    name: 'AI & ML',
    href: '#ai-ml'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-ucensys-navy/90 backdrop-blur-md border-b border-border-color py-4' : 'bg-transparent py-6'}`} data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <div className="flex items-center justify-between" data-id="element-72">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2 group" data-id="element-73">
            <span className="text-2xl font-heading font-bold text-ucensys-teal group-hover:text-ucensys-teal-light transition-colors" data-id="element-74">
              U|
            </span>
            <span className="text-xl font-heading font-semibold text-white tracking-tight" data-id="element-75">
              Ucensys
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-76">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-body font-medium text-text-secondary hover:text-white transition-colors" data-id="element-77">
                {link.name}
              </a>)}
            <a href="#contact" className="bg-teal-gradient text-white font-body font-semibold px-6 py-2.5 rounded-full hover:shadow-teal-glow transition-all duration-300 text-sm" data-id="element-78">
              Get Started
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-text-secondary hover:text-white transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu" data-id="element-79">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-80" /> : <MenuIcon className="w-6 h-6" data-id="element-81" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-ucensys-card border-b border-border-color shadow-xl" data-id="element-82">
          <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-83">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-body font-medium text-text-secondary hover:text-white transition-colors px-2 py-1" onClick={() => setIsMobileMenuOpen(false)} data-id="element-84">
                {link.name}
              </a>)}
            <div className="pt-4 border-t border-border-color" data-id="element-85">
              <a href="#contact" className="flex justify-center w-full bg-teal-gradient text-white font-body font-semibold px-6 py-3 rounded-full hover:shadow-teal-glow transition-all duration-300" onClick={() => setIsMobileMenuOpen(false)} data-id="element-86">
                Get Started
              </a>
            </div>
          </div>
        </div>}
    </header>;
}